module.exports = __webpack_public_path__ + "static/media/cat.a01ae97e.PNG";